import { UserSkill } from './skill.type'

export type UserModel = {
    id: number
    pseudo: string
    role: string
    email: string
    connectionAttempt?: number
    firstName: string
    lastName: string
    dayOfBirth: string
    gender: string
    licenseNumber: string
    tel: string
    notifySkillChanges: boolean
    skills: UserSkill[]
}

export type UserContextType = {
    tokenAdmin: string
    adminData: any
    tokenMember: string
    memberData: any
    tokenCoach: string
    coachData: any
    refreshUserData?: () => void
}

type Role = 'ROLE_MEMBER' | 'ROLE_ADMIN' | 'ROLE_COACH'

export type DecodedToken = {
    id: number
    role: Role
}

export const roles = {
    ROLE_MEMBER: 'ROLE_MEMBER',
    ROLE_ADMIN: 'ROLE_ADMIN',
}
